<div class="wrap">
  <div *ngIf="!isCreationMode && !isSessionMode && !isFileMode" class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" (click)="back()" appChangeColorTheme attribute="color">
      </fa-icon>
      <h2>Liste des articles</h2>
    </div>

    <div class="add_search_offer">
      <div class="add_offer" (click)="addOffer()" appChangeColorTheme [isHover]="true">
        <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
        <span>Ajouter un article</span>
      </div>

      <div class="search_bar">
        <form [formGroup]="searchForm">
          <input type="text" placeholder="Chercher un article ..." (input)="applyFilter($event.target.value)"
            formControlName="keyword">

          <fa-icon [icon]="valueInput? getFaIcon('faTimes') : getFaIcon('faSearch')"
            (click)="valueInput? resetSearch(): null" class="faTimes">
          </fa-icon>
        </form>
      </div>
    </div>
  </div>

  <div class="content" [style.grid-template-columns]="'1fr 35%'">
    <!-- admin-offers-table -->
    <ng-container *ngIf="isCreationMode">
      <app-admin-offer-edit [offer]="offerToEdit ?? null" (editFinished)="onEditFinished($event)"
        (offerPreviewUpdate)="changeOfferPreview($event)" (imageUpdate)="imageUpdate=$event"
        (switchToSession)="switchToSessionView($event)"></app-admin-offer-edit>
    </ng-container>

    <ng-container *ngIf="!isCreationMode && !isSessionMode && !isFileMode">
      <app-admin-offers-table *ngIf="!isLoading" [offers]="offers" (offerPreviewUpdate)="changeOfferPreview($event)"
        (onEdit)="onEdit($event)" (switchToSession)="switchToSessionView($event)"
        (switchToFiles)="switchToFilesView($event)" (imageUpdate)="imageUpdate=$event"
        (refreshOffers)="getOffers()"></app-admin-offers-table>

      <mat-spinner class="offersSpinner" *ngIf="isLoading" diameter="50"></mat-spinner>
    </ng-container>

    <ng-container *ngIf="isSessionMode">
      <app-admin-offer-session [offer]="offerToEdit" (editFinished)="onEditFinished($event)"></app-admin-offer-session>
    </ng-container>

    <ng-container *ngIf="isFileMode">
      <app-admin-offer-file [offerKey]="offerToEdit.offerKey"
        (editFinished)="onEditFinished($event)"></app-admin-offer-file>
    </ng-container>


    <!-- admin-preview-offer -->
    <app-admin-preview-offer *ngIf="!isSessionMode" [offerPreview]="offerPreview" [offerToEdit]="offerToEdit" [imageUpdate]="imageUpdate">
    </app-admin-preview-offer>

  </div>
</div>
